<template>
  <div>
    <home-header></home-header>
    <div class="wrapper pt-3">
      <div class="bg-white row">
        <div class="col">
          <div class="p-3">
            <el-form ref="form" :model="form" class="search-form" label-width="70px">
              <el-form-item label="搜索条件" class="mb-3">
                <el-input placeholder="请输入内容" v-model="form.search_value" class="input-with-select">
                </el-input>
                <el-button type="primary" @click="btn_run_query"
                           class="ml-2">搜索节点
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="col">
          <div class="col-right">
            <div id="mapContainer" class="bg-white">
              <div class="card-block search_list pt-2">
                <div v-if="listLoading" class="item">
                  <div class="h-420">
                    <div class="loading_position">
                      <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
                      <span class="d-block">加载中...</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="pb-3 pl-3">
                    <el-pagination layout="total, prev, pager, next" @current-change="panel_pagechange"
                                   :page-size="this.panel_page.size" :total="this.panel_page.total"
                                   :current-page="this.panel_page.index+1">
                    </el-pagination>
                  </div>
                  <div class="row pl-3">
                    <div class="float-left pr-3 pb-3" v-for="item in dataList">
                      <div class="dataset-card el-card is-always-shadow card-body">
                        <h5 class="card-title cursor-pointer" @click="open_chain(item)">{{ item.label }}</h5>
                        <!--
                        <p v-if="item.remark" class="card-text">{{ item.remark }}</p>
                        <p v-else class="">
                          数据集描述文本，该数据集来自于国家权威大数据平台，经先进的AI模型分析得到</p>
                        -->
                        <div class="mb-2">
                          <el-tag type="primary" effect="dark" size="mini">节点:{{ item.nodes }}个</el-tag>
                        </div>
                        <div class="mb-2">
                          <el-tag type="success" effect="dark" size="mini">企业:{{ item.cntReal }}</el-tag>
                          <el-tag type="info" effect="dark" size="mini">核心人员:{{ item.cnt }}</el-tag>
                        </div>
                        <div class="text-muted mb-2">最近更新: {{ item.addtime|formatDateTime }}</div>
                        <div>
                          <el-button type="" size="mini" @click="open_chain(item)">查看详情</el-button>
                          <el-button type="danger" plain size="mini" @click="export_data(item)">导出数据</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <export-data :dlg_export_model="dlg_export_model" :form="form"
                   @exportClose="dlg_export_model=false"></export-data>
    </div>
    <home-footer></home-footer>
  </div>
</template>

<script>
import api from "../../api/rest";
import util from "../../api/util";
import chartData from "../../api/chartData";
import ExportData from "../../components/ExportData.vue";
import HomeHeader from "../../components/HomeHeader.vue";
import HomeFooter from "../../components/HomeFooter.vue";

export default {
  components: {HomeFooter, HomeHeader, ExportData},
  data() {
    return {
      dataType: "chain",
      panel_page: {
        total: 0,
        index: 0,
        size: 20,
      },
      form: {
        search_value: '',
        idx: 'ent',
      },
      dataList: [],
      listLoading: false,
      dlg_export_model: false,
    }
  },
  methods: {
    open_chain(item) {
      window.location.href = '/#/detail?id=' + item.id
      // window.location.reload()
    },
    btn_run_query() {
      this.panel_page = {
        total: 0,
        index: 0,
        size: 20,
      }
      this.search_action()
    },
    export_data(item) {
      this.form.chain = item.code
      this.form.total = item.cntReal
      this.form.totalAmount = item.cntReal / 100
      this.dlg_export_model = true
    },
    getImageUrl() {

    },
    btn_cancel() {
      this.form = {
        search_value: ''
      }
      this.panel_page = {
        total: 0,
        index: 0,
        size: 20,
      }
      this.search_action()
    },
    panel_pagechange(val) {
      this.panel_page.index = val - 1;
      this.search_action()
    },
    // 列表
    search_action() {
      this.listLoading = true
      let para = {
        ...this.panel_page
      }
      para.search_value = this.form.search_value;
      para.type = this.dataType
      let api_url = '/menu/list'
      api.remote.doPost(para, api_url).then((res) => {
        if (res.status == "error") {
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
        }
        this.listLoading = false
        this.dataList = res.content;
        this.panel_page.total = res.totalElements
      }).catch((res) => {
        this.listLoading = false
        api.handError.action(this, res);
      });
    },
    set_map_height() {
      const myDiv = document.getElementById('mapContainer');

      function setDivHeight() {
        const windowHeight = window.innerHeight;
        myDiv.style.minHeight = windowHeight - 288 + "px"
      }

      window.addEventListener('resize', setDivHeight);
      setDivHeight();
    },
  },
  filters: {
    formatDateTime(time) {
      const currentDate = new Date();
      const oneDay = 24 * 60 * 60 * 1000;
      const twentyDays = 17 * oneDay;
      const newDate = new Date(currentDate.getTime() - twentyDays);
      return newDate.format("yyyy-MM-dd")
    }
  },
  mounted() {
    this.set_map_height()
    this.search_action()
  }
}
</script>
<style scoped>
.dataset-card {
  padding: 15px;
  height: 142px;
  width: 246px;
}
</style>



// WEBPACK FOOTER //
// Chain.vue?39160fd6